import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#2f6947',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#2f6947',
        warning: '#FFC107',
      },
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      sort: 'fas fa-arrow-up',
    },
  },
});
